{
  "list": {
    "title": "التصنيفات",
    "add": "إضافة تصنيف",
    "columns": {
      "nameAr": "الاسم بالعربية",
      "nameEn": "الاسم بالإنجليزية",
      "description": "الوصف",
      "status": "الحالة"
    },
    "rowActions": {
      "trigger": "إجراءات {{name}}"
    }
  },
  "drawer": {
    "createTitle": "إضافة تصنيف",
    "editTitle": "تعديل التصنيف",
    "createDescription": "تعبر التصنيفات عن مدى موثوقية العميل.",
    "editDescription": "تحديث بيانات هذا التصنيف.",
    "fields": {
      "nameAr": "الاسم بالعربية",
      "nameEn": "الاسم بالإنجليزية",
      "description": "الوصف"
    },
    "created": "تم إنشاء التصنيف بنجاح",
    "updated": "تم تحديث التصنيف بنجاح"
  },
  "statusConfirmTitle": "تغيير حالة هذا التصنيف؟",
  "statusConfirmActivateDescription": "سيصبح {{name}} متاحا في نافذة إضافة العميل.",
  "statusConfirmDeactivateDescription": "سيتم إخفاء {{name}} من نافذة إضافة العميل، ويبقى على العملاء الحاليين.",
  "deleteConfirmTitle": "حذف هذا التصنيف؟",
  "deleteConfirmDescription": "سيتم حذف {{name}} نهائيا. لا يمكن التراجع عن هذا الإجراء.",
  "deleted": "تم حذف التصنيف بنجاح",
  "statusChanged": "تم تغيير حالة التصنيف بنجاح"
}
